import script from "./UploadImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadImage.vue?vue&type=script&lang=ts&setup=true"

import "./UploadImage.vue?vue&type=style&index=0&id=f39c8318&lang=scss"

const __exports__ = script;

export default __exports__